'use strict';

// export this package's api
module.exports = require('./Pagination');


//////////////////
// WEBPACK FOOTER
// ./~/_rc-pagination@1.7.5@rc-pagination/lib/index.js
// module id = 1668
// module chunks = 0